<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-2">
            <bita-bootbutton
              v-if="this.$acl.isSuperAdmin || $acl.can('create', 'campaign')"
              type="primary"
              title="ایجاد کمپین"
              icon="fas fa-plus-square"
              class="w-100"
              @click.native="createCampaign"
            />
<!-- <bita-bootbutton
  type="primary"
  title="ثبت و پرداخت تست"
                @click.native="submitCampaignOrder"


/> -->


          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
           
            :schema-total="'total'"
            :schema-data="'data'"
            :batch="true"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="form"
      :props-products="products"
      modal-id="edit-modal"
      title="ویرایش کمپین"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :props-data="form"
      :props-products="products"
      :isLoading="isLoadingModal"
      modal-id="create-modal"
      title="کمپین جدید"
      @on-submit="handleCreate"
    />


    <!-- Actions -->
    <g-context-menu ref="contextMenu" #default="{items: campaign}">
      <g-list>
        <g-list-item
          title="ویرایش کمپین"
          icon="fas fa-pen-square"
          @click="edit(campaign)"
        />
        <g-list-item
          title="لیست مشارکت"
          icon="fas fa-list"
          @click="particiption(campaign)"
        />
        <g-list-item
          title="حذف کمپین"
          icon="fa fa-times"
          @click="deleteArticle(campaign)"
        />
      </g-list>
    </g-context-menu>
  </div>
</template>

<script>
import Form from "./Form";
import Views from "./Views";
import GContextMenu from "../../components/GContextMenu.vue";
import GList from "../../components/listItem/GList.vue";
import GListItem from "../../components/listItem/GListItem.vue";

export default {
  components: {
    "form-modal": Form,
    "views-modal": Views,
    GContextMenu,
    GList,
    GListItem,
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "کمپین ها",
          link: "/campaigns",
          active: true,
        },
      ],
      isLoadingForm: false,
      isLoadingGrid: false,
      isLoadingModal: false,
      form: {
        id: 0,
        title: "",
        description: "",
        publish_at: "",
        expire_at: "",
        review_at: "",
        early_release:false ,
        show_participation: false,
        min_participation:"",
        mix_participation:"",
        thumbnail: "",
        product_id:[],
      },
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "title", title: "عنوان کمپین", width: "80px" },
        { field: "participation_count", title: "میزان مشارکت", width: "80px" },
        { field: "show_participation",
         title: "انتشار پیش از موعد",         
         template: (e) => this.statusText(e.early_release),
         width: "80px" },

        {
          field: "publish_at",
          title: "تاریخ انتشار",
          template: (e) =>
            e.publish_at ? this.$getJalaliDateTime(e.publish_at) : "-",
          width: "80px",
        },
        {
          field: "expire_at",
          title: "تاریخ انقضا",
          template: (e) =>
            e.expire_at ? this.$getJalaliDateTime(e.expire_at) : "-",
          width: "80px",
        },
        {
          field: "expire_at",
          title: "تاریخ اعلام نتایج",
          template: (e) =>
            e.expire_at ? this.$getJalaliDateTime(e.expire_at) : "-",
          width: "80px",
        },
        {
          title: "عملیات",
          command: [],
          width: 50,
        },
      ],
      products: [],
    };
  },
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    Promise.all([this.getProducts()]).then((res) => {
      this.products = res[0].data;

    });
  },
  methods: {

    statusText(e) {
      return e == 1
        ? "<span class='label label-primary'> فعال </span>"
        : "<span class='label label-danger'> غیرفعال </span>";
    },

  getFormData(data) {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      const value = data[key];

      if (Array.isArray(value)) {
        value.forEach(val => formData.append(key + '[]', val)); 
      } else if (value instanceof File) {
        formData.append(key, value); 
      } else {
        formData.append(key, value); 
      }
    });

    return formData;
  },
    gridCommands() {
      return [
        {
          text: "view",
          click: this.showActions,
          template:
            "<a role='button' class='k-button k-button-icontext k-grid-view'><span class='fas fa-ellipsis-v' style='color:rgb(20 169 217)'></span></a>",
        },
      ];
    },
    showActions(e) {
      e.originalEvent.stopPropagation();

      const request = this.$refs.grid.getSelectedGridRow(e);

      this.$refs.contextMenu.init(e.originalEvent, request);
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.$resetGrid();
      this.$persistClient("get", "campaigns/allCampaigns")
        .then((res) => {
          e.success(res.data);

        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
 
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();

      this.$persistClient("get", "campaigns/allCampaigns").then((res) => {
        this.data = res.data;
      });


    },
    edit(campaign) {
      this.form = campaign;
      this.statusChangeModalEdit();
    },
    deleteArticle(campaign) {
      this.$alert(
        "question",
        `آیا از حذف ${campaign.title} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `campaigns/${campaign.id}`)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    particiption(campaign) {
      this.$router.push(`/campaigns/${campaign.id}/participation/`);
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    createCampaign() {
      this.form = {};
      this.statusChangeModalCreate();
    },
    handleEdit(e) {
      this.isLoadingModal = true;
      let data = {
        ...e,
        _method: "patch",
      };
      this.$persistClient(
        "post",
        `campaigns/${e.id}`,
        this.getFormData(data)
      )
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalEdit();
        });
    },
    handleCreate(e) {
      this.isLoadingModal = true;
      let data = {
        ...e,
      };
      this.$persistClient(
        "post",
        "campaigns",
        this.getFormData(data)
      )
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
          this.statusChangeModalCreate();
        })
        .finally((res) => {
          this.isLoadingModal = false;
        });
    },
        getProducts() {
      return this.$persistClient("get", "campaigns/products");
    },

  },





};
</script>
